<template>
  <div class="preview-box add-trial">
    <div class="preview-box-container">
      <div class="preview-box-action-container">
          <div class="preview-box-tools">
            <TrialConfirmView
              :title="'Add Free Trial Package'"
              :action="actionAddTrial"
              :confirmDisabled="!isFormValid"
              @on-action-done="onActionDone"
              @cancel="onCancel"
            >
              <template v-slot:confirm>
                  <div>
                    <label>Project key</label>
                    <input type="text" v-model="actionAddTrial.project_key" placeholder="Enter project key"/>
                  </div>
                  <div>
                    <label>Packages<span>*</span></label>
                    <select v-model="actionAddTrial.package" placeholder="Choose a package">
                      <option value="" disabled selected>Choose a package</option>
                      <template v-for="type in packageList">
                        <option v-if="type.key"
                         :key="type" :value="type.key" >{{type.name}}</option>
                      </template>
                    </select>
                  </div>
                  <div>
                    <h2>Expiry Date</h2>
                      <label>Select a type<span>*</span></label>
                      <select v-model="actionAddTrial.expiry_date_type">
                        <option value="" disabled selected>Select</option>
                        <option :value="'date'">Date</option>
                        <option :value="'days'">Days</option>
                      </select>
                    <template v-if="actionAddTrial.expiry_date_type === 'days'">
                      <label>Days<span>*</span></label>
                      <input type="number" v-model="actionAddTrial.expiry_date" min="1"/>
                    </template>
                    <template v-if="actionAddTrial.expiry_date_type === 'date'">
                      <label>Date<span>*</span></label>
                      <input
                        type="date"
                        v-model="actionAddTrial.expiry_date"
                        :min="minDate"
                      />
                    </template>
                  </div>
                </template>
              <template v-slot:linkGenerated>
                <div>
                    <KeyBox
                      v-if="generatedLink"
                      class="credentials__key-box"
                      :keyData="generatedLink"
                      :labelData="'link'"
                    />
                  </div>
              </template>
            </TrialConfirmView>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ref,
  onMounted,
  computed,
} from 'vue';
import { ProjectList, AdminAction } from '@/store/modules/admin';
import moment from 'moment';
import KeyBox from '@/components/KeyBox.vue';

import TrialConfirmView from '@/components/admin/TrialConfirmView.vue';

export const datePickerFormat = (date) => moment.unix(date).format('DD/MM/YYYY');

export default {

  components: {
    TrialConfirmView,
    KeyBox,

  },

  setup() {
    const packageList = ref([]);
    const generatedLink = ref('');

    const minDate = moment().format('YYYY-MM-DD');

    const getUnixTimeStamp = (days) => {
      const timeStamp = moment().add(days, 'days').unix();
      return timeStamp;
    };

    const actionAddTrial = ref(
      new AdminAction(async () => {
        const expiresAt = (actionAddTrial.value.expiry_date_type === 'date'
           || !actionAddTrial.value.expiry_date_type)
          ? moment(actionAddTrial.value.expiry_date, 'YYYY-MM-DD').unix()
          : getUnixTimeStamp(actionAddTrial.value.expiry_date);

        const response = await ProjectList.generateTrialLink({
          package: actionAddTrial.value.package,
          project_key: actionAddTrial.value.project_key,
          expires_at: expiresAt,
        });

        generatedLink.value = response.link;

        return response;
      }),
    );

    const isFormValid = computed(() => {
      if (!actionAddTrial.value.package) return false;
      if (!actionAddTrial.value.expiry_date_type) return false;
      if (!actionAddTrial.value.expiry_date) return false;

      if (actionAddTrial.value.expiry_date_type === 'days') {
        const days = parseInt(actionAddTrial.value.expiry_date, 10);
        if (days < 1) return false;
      }

      return true;
    });

    const fetchPackages = () => {
      const params = {
        active: true,
      };
      ProjectList.fetchPackageInfo(params).then((resp) => {
        packageList.value = resp.response;
      });
    };

    onMounted(() => {
      fetchPackages();
    });

    const resetForm = {
      project_key: '',
      package: '',
      expiry_date: '',
      expiry_date_type: '',
    };

    const onActionDone = (action, response) => {
      generatedLink.value = response.link;
    };

    const onCancel = () => {
      Object.assign(actionAddTrial.value, resetForm);
      generatedLink.value = '';
    };

    return {
      actionAddTrial,
      onActionDone,
      packageList,
      minDate,
      onCancel,
      generatedLink,
      KeyBox,
      isFormValid,
    };
  },
};
</script>
<style lang="scss">
.add-trial {
  &.preview-box {
    .preview-box-tools {
      margin: 0 auto;
      padding: 0!important;
      .btn {
        &.btn-sm {
          margin-bottom: 0;
          margin-right: 0;
        }
      }
      .error-msg {
        padding: size(10) 0;
        color: var(--global--error--BackgroundColor);
      }
      .body {
        h2 {
          border-bottom: size(1) solid var(--global--supportive--Color);
          padding-bottom: size(10);
          margin: size(20) 0;
        }
        >div {
          label {
            margin-bottom: size(6);
            color: var(--global--supportive--Color);
            font-size: size(12);
            line-height: size(18);
            span {
                color: var(--global--error--BackgroundColor);
                padding-left: size(2);
        }
          }
          select, input, textarea, p {
            display: block;
            width: 100%;
            border-radius: size(4);
            color: var(--global--white--Color);
            padding: size(6);
            font-size: size(14);
            line-height: size(20);
            background: none;
            outline: var(--global--supportive--Color);
            border: size(1) solid var(--global--supportive--Color);
          }
          select {
            border: 0;
            outline: size(1) solid var(--global--supportive--Color);
            border-right: size(10) solid transparent;
            appearance: none;
            background-image: url('../../assets/dropdown-white.svg');
            background-repeat: no-repeat;
            background-position: top size(5) right 0;

            option {
              color: var(--global--main--Color);
            }
          }

          input[type="date"] {
            &::-webkit-calendar-picker-indicator {
              filter: invert(1);
            }
          }
        }
      }
      p {
        &.text {
          display: inline-block;
          padding: 0;
          color: var(--global--white--Color);
          font-size: size(14);
          font-style: normal;
          margin-bottom: size(25);
        }
      }
      label {
        display: inline-block;
        vertical-align: top;
        margin-right: size(25);
        margin-top: 0;
        min-width: size(180);
        span {
          color: var(--global--error--BackgroundColor);
          padding-left: size(2);
        }
      }
      .tools {
        margin-top: size(25);
        text-align: right;
      }
      .error {
        padding: size(20) 0;
        color: var(--global--error--BackgroundColor);
        font-size: size(15);
      }
      .start-date, .end-date {
        display: inline-block;
        svg {
          width: size(12);
        }
      }
    }
    .generate-link-btn {
      text-decoration: underline;
      font-size: size(14);
      line-height: size(18);
      cursor: pointer;
      color: var(--admin--color-level2);
    }
  }
  .button-wrapper {
    text-align: right;
    margin-top: size(30);
  }
  .key-box {
    padding-bottom: 0;
    border-bottom: 0;

    margin-top: size(10);

    h5 {
      margin-bottom: size(6);
      color: var(--global--supportive--Color);
      font-size: size(12);
      line-height: size(18);
      padding-bottom: 0;
    }

    .key-box-info {
      input {
        margin-bottom: 0;
      }

      svg {
        filter: invert(1);
      }
    }
  }
}
</style>
